import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { useInteractionHandler } from '../hooks/use-interaction-handler.js';
import { useLinkBehavior } from '../settings/settings.link-behavior.js';
import { HAS_WINDOW } from '../utils/window.js';

const REL_TRUSTED = 'noopener';
const REL_UNTRUSTED = 'noopener nofollow noreferrer ugc';
/**
 * Renders an <a> tag with safe defaults.
 *
 * @see https://fpl.figma.design/primitives/link/
 */
const LinkPrimitive = forwardRef(({ recordingKey, children, href, trusted, newTab, onClick, rel: relIn, target: targetIn, ...props }, ref) => {
    const override = useLinkBehavior();
    const rel = relIn ?? ((trusted ?? inferTrust(href)) ? REL_TRUSTED : REL_UNTRUSTED);
    const target = targetIn ?? (newTab ? '_blank' : undefined);
    const recordedOnClick = useInteractionHandler(onClick || override
        ? (e) => {
            override?.(e);
            onClick?.(e);
        }
        : undefined, { eventName: 'click', recordingKey }, [onClick, override]);
    return (jsx("a", { "data-fpl-component": "primitive", ...props, ref: ref, href: href, rel: rel, target: target, onClick: recordedOnClick, children: children }));
});
LinkPrimitive.displayName = 'LinkPrimitive';
function inferTrust(href) {
    if (!HAS_WINDOW)
        return false;
    try {
        const origin = window.location.origin;
        const url = new URL(href, origin);
        return url.origin === origin;
    }
    catch {
        // There are cases where the URL constructor will fail, e.g. when window.location.origin is
        // 'null' which occurs when loading from a custom file protocol in the desktop app.
        return false;
    }
}

export { LinkPrimitive };
//# sourceMappingURL=link-primitive.js.map
